(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      // Dawn used IntersectionObserver.intersectionRect, which is empty
      // when the page loads scrolled past the header, leaving bounds at 0.
      // Measure the header's real document position instead.
      const rect = this.header.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.headerBounds = {
        top: rect.top + scrollTop,
        bottom: rect.bottom + scrollTop,
      };
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Deliberately does NOT add scrolled-past-header here. Dawn's
        // original did, which meant scrolling down restyled the header
        // to the solid/blurred version for the split second before it
        // slid out of view. The solid style is only wanted on the
        // reveal (scroll up), so it's added in that branch only.
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Transparent header only when the first section actually sits behind it
  // (a hero pulled up under the header). If the page starts below the
  // header, there's nothing to see through, so the header stays solid.
  (function () {
    function check() {
      var header = document.querySelector('.section-header');
      var main = document.getElementById('MainContent');
      if (!header || !main) return;
      var first = null;
      var kids = main.children;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].offsetHeight > 0) { first = kids[i]; break; }
      }
      // A section sits behind the header only when it's pulled up above
      // where the main content starts (negative top margin). Comparing the
      // two inside the page avoids measuring the header itself, whose
      // position depends on what's above it (announcement bar or not) and
      // on whether it's currently stuck.
      var behind = first && first.getBoundingClientRect().top < main.getBoundingClientRect().top - 1;
      header.classList.toggle('hlh-solid', !behind);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', check);
    } else {
      check();
    }
    window.addEventListener('load', check);
    window.addEventListener('resize', check);
    // Theme editor: re-check when sections are added, moved or removed
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(check, 50); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
